@borderColor: #e8e9e9;

.stickyHeader {
	thead {
		position: sticky;
		top: -1.6rem;
		z-index: 3;
	}

	tr {
		background-color: #ffffff;
	}
}

.stickyHeaderLessMarginTop {
	& {
		.stickyHeader;
	}

	thead {
		top: -1rem;
	}
}

.spec-items-verification-matrix {
	// The default border color is black with transparency which causes the borders to overlap when scrolled horizontally.
	// Therefore we use a color without transparency.

	thead {
		border-top: 1px solid @borderColor !important;
		position: sticky;
		top: -1.6rem;
		z-index: 3;
	}

	th,
	td {
		border-color: @borderColor !important;
	}

	// The border radius on the left causes content that is scrolled behind the sticky elements
	// to appear in the corner cutout. To avail this we remove the radius
	&,
	thead tr:first-child > th:first-child {
		border-top-left-radius: 0 !important;
	}

	&,
	tbody tr:last-child > td:first-child {
		border-bottom-left-radius: 0 !important;
	}

	// As the celled Semantic UI table uses border-collapse: separate and sets only the left/outer-most border to a
	// non-zero width the leftmost border sticks to the table and scrolls out of view when scrolling horizontally.
	// We overwrite this here to have the border set for the th/td cells instead which are kept in place
	border-left: none !important;

	th:first-child,
	td:first-child {
		border-left: 1px solid @borderColor !important;
	}

	// Similarly to the first column the third column own the border by default, which causes it to disappear under the
	// first columns when scrolled. Instead we attribute the column to the right border of the second column
	th:nth-of-type(2),
	td:nth-of-type(2) {
		border-right: 1px solid @borderColor !important;
	}

	th:nth-of-type(3),
	td:nth-of-type(3) {
		border-left: none !important;
		border-left-width: 0 !important;
	}

	.sticky-left {
		z-index: 2;
		position: -webkit-sticky !important;
		position: sticky !important;

		// Combined with 'position: sticky', the 'left' value tells the browser where to stop moving the element when scrolling horizontally.
		// The value '0' only works for the first column.
		&:nth-of-type(1) {
			left: 0;
			min-width: 250px;
		}

		// The 'left' value for the second column has to be set to the width of the first table column.
		// Otherwise, the second column will slide over the first when scrolling sideways.
		// The variable is set from Typescript
		&:nth-of-type(2) {
			left: var(--first-column-width);
		}
	}

	// We have to set a background color because the first two table columns are sticky.
	// Otherwise, the scrolling content will be visible underneath the sticky columns.
	tr {
		th.sticky-left {
			&:first-of-type {
				padding: 0;
				position: relative;

				.header-image {
					display: block;
				}

				.left-bottom-text {
					position: absolute;
					bottom: 8px;
					left: 10px;
				}

				.right-top-text {
					position: absolute;
					top: 8px;
					right: 10px;
				}
			}
		}

		&,
		td {
			background: #fff;
			opacity: 1;
		}
	}

	tbody tr:nth-child(2n) {
		&,
		td {
			background: hsl(0deg 0% 96%);
			opacity: 1;
		}
	}
}

.execution-bar-with-link {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.full-width-cell-content > * {
	width: 100%;
	display: block;
	text-align: right;
}
